import { CustomModal } from "components/CustomModal"
import { useTranslation } from "react-i18next"
import { Button } from "@/components/ui/button"
import { EmptyPage } from "../EmptyPage"

export const ReEnterIntegration = () => {
  const { t } = useTranslation()
  const integrationURL = "https://tintdemostore.mitiendanube.com/admin/v2/apps"

  const handleIntegrationClick = () => {
    window.location.href = integrationURL
  }

  return (
    <div data-testid="re-enter-integration-page">
      <EmptyPage>
        <CustomModal
          isOpen={true}
          title={t("reEnterIntegration.supportTeam")}
          showCloseButton={false}
          startTitleIcon={<img src={"/tint-logo-small.svg"} alt="" />}
        >
          <div className="flex max-w-[560px] flex-col items-center gap-5 py-2.5 pb-5">
            <h2 className="text-xl font-semibold text-center">
              {t("reEnterIntegration.reenterAccount")}
            </h2>

            <p className="text-sm text-center mt-2">
              {t("reEnterIntegration.reconnectDescription")}
            </p>

            <div>
              <Button
                onClick={handleIntegrationClick}
                className="w-full mt-4"
                data-testid="re-enter-integration-action"
              >
                {t("reEnterIntegration.reconnectButton")}
              </Button>
            </div>
          </div>
        </CustomModal>
      </EmptyPage>
    </div>
  )
}
